export const categoriesData = {
    categories: [
      {
        name: 'Groceries',
        subCat: [
          {
            "name": "Fruits & Vegetables",
            "subSubCat": [
              { "name": "Fresh Fruits", "id": "fresh-fruits", "image": "https://www.jiomart.com/images/category/220/fresh-fruits-20200704.jpg" },
              { "name": "Fresh Vegetables", "id": "fresh-vegetables", "image": "https://www.jiomart.com/images/category/229/fresh-vegetables-20200704.jpg" },
              { "name": "Herbs & Seasonings", "id": "herbs-seasonings", "image": "https://www.jiomart.com/images/category/233/herbs-seasonings-20200704.jpg" },
              {
                "name": "Exotic Fruits & Vegetables",
                "id": "exotic-fruits-vegetables",
                "image": "https://www.jiomart.com/images/category/243/exotic-fruits-vegetables-20200618.jpg"
              }
            ],
            "id": "fruits-vegetables",
            "image": ""
          },
          {
            "name": "Dairy & Bakery",
            "subSubCat": [
              { "name": "Dairy", "id": "dairy", "image": "https://www.jiomart.com/images/category/62/dairy-20200704.jpg" },
              { "name": "Toast & Khari", "id": "toast-khari", "image": "https://www.jiomart.com/images/category/102/toast-khari-20200704.jpg" },
              { "name": "Cakes & Muffins", "id": "cakes-muffins", "image": "https://www.jiomart.com/images/category/125/cakes-muffins-20200730.jpg" },
              { "name": "Breads and Buns", "id": "breads-and-buns", "image": "https://www.jiomart.com/images/category/267/breads-and-buns-20200704.jpg" },
              { "name": "Baked Cookies", "id": "baked-cookies", "image": "https://www.jiomart.com/images/category/281/bakery-snacks-20200730.jpg" },
              { "name": "Bakery Snacks", "id": "bakery-snacks", "image": "https://www.jiomart.com/images/category/281/bakery-snacks-20200730.jpg" },
              { "name": "Batter & Chutney", "id": "batter-chutney", "image": "" },
              { "name": "Cheese", "id": "cheese", "image": "" },
              { "name": "Ghee", "id": "ghee", "image": "" },
              { "name": "Paneer & Tofu", "id": "paneer-tofu", "image": "" }
            ],
            "id": "dairy-bakery",
            "image": ""
          },
          {
            "name": "Staples",
            "subSubCat": [
              {
                "name": "Atta, Flours & Sooji",
                "id": "atta-flours-sooji",
                "image": "https://www.jiomart.com/images/category/26/atta-flours-sooji-20200704.jpg"
              },
              { "name": "Dals & Pulses", "id": "dals-pulses", "image": "https://www.jiomart.com/images/category/17/dals-pulses-20200704.jpg" },
              {
                "name": "Rice & Rice Products",
                "id": "rice-rice-products",
                "image": ""
              },
              { "name": "Edible Oils", "id": "edible-oils", "image": "https://www.jiomart.com/images/category/58/edible-oils-20200704.jpg" },
              { "name": "Masalas & Spices", "id": "masalas-spices", "image": "https://www.jiomart.com/images/category/21/masalas-spices-20200704.jpg" },
              {
                "name": "Salt, Sugar & Jaggery",
                "id": "salt-sugar-jaggery",
                "image": "https://www.jiomart.com/images/category/23/salt-sugar-jaggery-20200704.jpg"
              },
              {
                "name": "Soya Products, Wheat & Other Grains",
                "id": "soya-products-wheat-other-grains",
                "image": "https://www.jiomart.com/images/category/106/soya-products-wheat-other-grains-20200704.jpg"
              },
              { "name": "Dry Fruits & Nuts", "id": "dry-fruits-nuts", "image": "https://www.jiomart.com/images/category/657/dry-fruits-nuts-20201014.jpeg" }
            ],
            "id": "staples",
            "image": ""
          },
          {
            "name": "Snacks & Branded Foods",
            "subSubCat": [
              { "name": "Biscuits & Cookies", "id": "biscuits-cookies", "image": "https://www.jiomart.com/images/category/11/biscuits-cookies-20200704.jpg" },
              {
                "name": "Noodle, Pasta, Vermicelli",
                "image": "https://www.jiomart.com/images/category/86/noodle-pasta-vermicelli-20200715.jpg",
                "id": "noodle-pasta-vermicelli"
              },
              { "name": "Breakfast Cereals", "id": "breakfast-cereals", "image": "https://www.jiomart.com/images/category/98/breakfast-cereals-20200704.jpg" },
              { "name": "Snacks & Namkeen", "id": "snacks-namkeen", "image": "https://www.jiomart.com/images/category/43/snacks-namkeen-20200704.jpg" },
              {
                "name": "Chocolates & Candies",
                "id": "chocolates-candies",
                "image": "https://www.jiomart.com/images/category/70/chocolates-candies-20200704.jpg"
              },
              { "name": "Ready To Cook & Eat", "id": "ready-to-cook-eat", "image": "https://www.jiomart.com/images/category/53/ready-to-cook-eat-20200704.jpg" },
              {
                "name": "Frozen Veggies & Snacks",
                "id": "frozen-veggies-snacks",
                "image": "https://www.jiomart.com/images/category/111/frozen-veggies-snacks-20200730.jpg"
              },
              {
                "name": "Spreads, Sauces, Ketchup",
                "id": "spreads-sauces-ketchup",
                "image": "https://www.jiomart.com/images/category/55/spreads-sauces-ketchup-20200704.jpg"
              },
              { "name": "Indian Sweets", "id": "indian-sweets", "image": "https://www.jiomart.com/images/category/46/indian-sweets-20200704.jpg" },
              { "name": "Pickles & Chutney", "id": "pickles-chutney", "image": "https://www.jiomart.com/images/category/51/pickles-chutney-20200704.jpg" },
              {
                "name": "Extracts & Flavouring",
                "id": "extracts-flavouring",
                "image": "https://www.jiomart.com/images/category/181/extracts-flavouring-20200704.jpg"
              }
            ],
            "id": "snacks-branded-foods",
            "image": ""
          },
          {
            "name": "Beverages",
            "subSubCat": [
              { "name": "Tea", "id": "tea", "image": "https://www.jiomart.com/images/category/34/tea-20200712.jpg" },
              { "name": "Coffee", "id": "coffee", "image": "https://www.jiomart.com/images/category/94/coffee-20200704.jpg" },
              { "name": "Fruit juices", "id": "fruit-juices", "image": "https://www.jiomart.com/images/category/96/fruit-juices-20200704.jpg" },
              {
                "name": "Energy & Soft Drinks",
                "image": "https://www.jiomart.com/images/category/40/energy-soft-drinks-20200704.jpg",
                "id": "energy-soft-drinks"
              },
              {
                "name": "Health Drink & Supplement",
                "id": "health-drink-supplement",
                "image": "https://www.jiomart.com/images/category/49/health-drink-supplement-20200704.jpg"
              },
              {
                "name": "Soda & Flavoured Water",
                "id": "soda-flavoured-water",
                "image": "https://www.jiomart.com/images/category/115/soda-flavoured-water-20200730.jpg"
              }
            ],
            "id": "beverages",
            "image": ""
          },
          {
            "name": "Personal Care",
            "subSubCat": [
              { "name": "Hair Care", "id": "hair-care", "image": "https://www.jiomart.com/images/category/92/hair-care-20200704.jpg" },
              { "name": "Oral Care", "id": "oral-care", "image": "" },
              { "name": "Skin Care", "id": "skin-care", "image": "" },
              { "name": "Bath & Hand Wash", "id": "bath-hand-wash", "image": "" },
              {
                "name": "Body Wash & Bathing Accessories",
                "id": "body-wash-bathing-accessories",
                "image": ""
              },
              { "name": "Feminine Hygiene", "id": "feminine-hygiene", "image": "" },
              { "name": "Men's Grooming", "id": "men's-grooming", "image": "" },
              { "name": "Deo & Fragrances", "id": "deo-fragrances", "image": "" },
              { "name": "Health & Wellness", "id": "health-wellness", "image": "" },
              { "name": "Makeup", "id": "makeup", "image": "" },
              { "name": "Covid Essentials", "id": "covid-essentials", "image": "" }
            ],
            "id": "personal-care",
            "image": ""
          },
          {
            "name": "Home Care",
            "subSubCat": [
              { "name": "Detergents", "id": "detergents", "image": "https://www.jiomart.com/images/category/37/detergents-20200806.jpg" },
              { "name": "Dishwash", "id": "dishwash", "image": "" },
              {
                "name": "All Purpose Cleaners",
                "id": "all-purpose-cleaners",
                "image": ""
              },
              {
                "name": "Fresheners & Repellents",
                "id": "fresheners-repellents",
                "image": ""
              },
              { "name": "Shoe Care", "id": "shoe-care", "image": "" },
              { "name": "Pet Supplies", "id": "pet-supplies", "image": "" }
            ],
            "id": "home-care",
            "image": ""
          },
          {
            "name": "Baby Care",
            "subSubCat": [
              { "name": "Baby Grooming", "id": "baby-grooming", "image": "" },
              { "name": "Baby Bath & Hygiene", "id": "baby-bath-hygiene", "image": "" },
              { "name": "Diapers & Wipes", "id": "diapers-wipes", "image": "" },
              { "name": "Baby Food & Formula", "id": "baby-food-formula", "image": "https://www.jiomart.com/images/category/82/baby-food-formula-20200618.jpg" },
              { "name": "Health & Wellness", "id": "health-wellness", "image": "" }
            ],
            "id": "baby-care",
            "image": ""
          },
          {
            "name": "Home & Kitchen",
            "subSubCat": [
              { "name": "Pooja Needs", "id": "pooja-needs", "image": "" },
              { "name": "Disposables", "id": "disposables", "image": "" },
              { "name": "Electrical", "id": "electrical", "image": "" },
              {
                "name": "Mops, Brushes & Scrubs",
                "id": "mops-brushes-scrubs",
                "image": ""
              },
              { "name": "Furnishing", "id": "furnishing", "image": "" },
              { "name": "Stationery", "id": "stationery", "image": "" },
              { "name": "Home Appliances", "id": "home-appliances", "image": "" },
              {
                "name": "Toys, Games & Fitness",
                "id": "toys-games-fitness",
                "image": ""
              },
              { "name": "Kitchenware", "id": "kitchenware", "image": "" },
              { "name": "Dining", "id": "dining", "image": "" },
              {
                "name": "Bathroom & Laundry Accessories",
                "id": "bathroom-laundry-accessories",
                "image": ""
              },
              {
                "name": "Bags & Travel Luggage",
                "id": "bags-travel-luggage",
                "image": ""
              }
            ],
            "id": "home-kitchen",
            "image": ""
          }
        ]
        ,
      },
      {
        name: 'Fashion',
      },
      {
        name: 'Jewellery',
      },
    ],
  };
  
  
  
  
  
  // let data = {
  //   products: productList.Product.map((item) => ({
  //     ...item,
  //     MRP: Number(item.MRP.match(/[0-9|.]+/g)[0]),
  //     selling_price: Number(item.selling_price.match(/[0-9|.]+/g)[0]),
  //     discount: item.discount.match(/[0-9]+%/g)[0],
  //   })),
  // };
  
  
  
  
  // console.log(data.categories[0].subCat.)